import React from "react";
import { Link } from "../router";
import { useAuth } from "../context/AuthContext";

type NavItem = {
  key: string;
  label: string;
  to: string;
  permission?: string;
};

const NAV: NavItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    to: "/dashboard",
    permission: "dashboard.view",
  },
  {
    key: "ejecutivo",
    label: "Ejecutivo",
    to: "/ejecutivo",
    permission: "executive.view",
  },
  {
    key: "economia",
    label: "Economía",
    to: "/economia",
    permission: "economics.view",
  },
  {
    key: "inbox",
    label: "Inbox",
    to: "/inbox",
    permission: "inbox.view",
  },
  {
    key: "kanban",
    label: "Kanban",
    to: "/kanban",
    permission: "kanban.view",
  },
  {
    key: "leads",
    label: "Leads / Pacientes",
    to: "/leads",
    permission: "contacts.view",
  },
  {
    key: "tareas",
    label: "Tareas",
    to: "/tareas",
    permission: "tasks.view",
  },
  {
    key: "ventas",
    label: "Ventas",
    to: "/ventas",
    permission: "sales.view",
  },
  {
    key: "postventa",
    label: "Postventa",
    to: "/postventa",
    permission: "postcare.view",
  },
  {
    key: "retencion",
    label: "Retención",
    to: "/retencion",
    permission: "retention.view",
  },
  {
    key: "incidencias",
    label: "Incidencias",
    to: "/incidencias",
    permission: "issues.view",
  },
  {
    key: "agenda",
    label: "Agenda",
    to: "/agenda",
    permission: "agenda.view",
  },
  {
    key: "reportes",
    label: "Reportes",
    to: "/reportes",
    permission: "reports.view",
  },
  {
    key: "inventario",
    label: "Inventario",
    to: "/inventario",
    permission: "inventory.view",
  },
  {
    key: "configuracion",
    label: "Configuración",
    to: "/configuracion",
    permission: "configuration.view",
  },
  {
    key: "plantillas-tratamiento",
    label: "Plantillas de tratamiento",
    to: "/plantillas-tratamiento",
    permission: "treatment.templates.view",
  },
];

export default function Sidebar({
  active,
  open,
  onClose,
}: {
  active: string;
  open?: boolean;
  onClose?: () => void;
}) {
  const { user, hasPermission, permissionsLoading } = useAuth();

  const items = !user || permissionsLoading
    ? []
    : NAV.filter(
        (item) =>
          !item.permission ||
          hasPermission(item.permission)
      );

  return (
    <>
      {open && <div className="side-backdrop" onClick={onClose} />}

      <aside className={`side ${open ? "open" : ""}`}>
        <div className="side-header">
          <div className="brand">MAUVELORE CRM</div>

          <button
            className="side-close"
            onClick={onClose}
            aria-label="Cerrar menú"
          >
            ✕
          </button>
        </div>

        <nav className="nav">
          {items.map((item) => (
            <Link
              key={item.key}
              to={item.to}
              className={item.key === active ? "active" : ""}
              onClick={onClose}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
}
